import { FormEnginePlugin } from '@form-engine/core-application';
import type { ParseRemoteConfig } from 'papaparse';
import Datasource, {
    apiName,
    SourceType,
} from './datasources/static-datasource';

declare module '@form-engine/core-application/types/form' {
    interface DatasourceDefinitionSubType {
        [apiName]: {
            source?: string;
            sourceType?: SourceType;
            resultPath?: string;
            labelColumn?: string;
            valueColumn?: string;
            csvOptions?: ParseRemoteConfig;
            previousError?: Error;
            constantsPath?: string;
        };
    }
}

export default {
    datasources: {
        [apiName]: Datasource,
    },
} as FormEnginePlugin;
